import api from '../api/apiConfig'

export default {
  namespaced: true,
  state: {
    currentList: [],
    current: {},
    isPreviousTypeSheet: null,
    currentMembers: [],
    currentProjectMember: []
  },
  getters: {
    newProjectData (state) {
      let data = {...state.current}
      if (data.bidCost) {
        data.bidCost = Number.parseFloat(data.bidCost)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
      if (data.settlementCost) {
        data.settlementCost = Number.parseFloat(data.settlementCost)
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
      data.finishAt = data.finishAt || null
      return data
    },
    getTemplate (state) {
      const template = {
        dailyRecord: [{}, {}],
        errorRecord: [{}, {}],
        reviewApplication: [{}],
        testRecord: [{}],
        inspection: [{}]
      }
      template.dailyRecord[0] = {...state.current.dailyRecordTemplate.find(template => template.isSelected === true), type: '第一聯'}
      template.dailyRecord[1] = {...state.current.dailyPayItemsTemplate.find(template => template.isSelected === true), type: '第二聯'}

      template.errorRecord[0] = {...state.current.errorRecordTemplate.find(template => template.isSelected === true), type: '缺失改善'}
      template.errorRecord[1] = {...state.current.errorRecordListTemplate.find(template => template.isSelected === true), type: '缺失改善管制表'}

      template.reviewApplication[0] = {...state.current.reviewApplicationTemplate.find(template => template.isSelected === true)}

      template.testRecord[0] = {...state.current.testRecordTemplate.find(template => template.isSelected === true)}

      template.inspection[0] = {...state.current.inspectionListTemplate.find(template => template.isSelected === true), type: '自主檢查總表'}
      return template
    }
  },
  mutations: {
    setCurrent (state, current) {
      // 目前在router設定如果不是到main(sidebar catalog)，current project 設為 null
      if (current === null) {
        state.current = current
      } else {
        state.current = current
      }
    },
    setCurrentList (state, currentList) {
      state.currentList = currentList
    },
    setErrorRecordCodePrefix (state, prefix) {
      state.current.errorRecordPrefixCode = prefix
    },
    setCurrentMembers (state, v) {
      state.currentMembers = v
    },
    setCurrentProjectMember (state, members) {
      state.currentProjectMember = members
    }
  },
  actions: {
    async getProjectItemAndStore ({commit, state, dispatch, rootState}, condition) {
      commit('setCurrent', await api.getProject(condition))

      if (state.current.type !== rootState.enumData.projectType.sheet.value) {
        const member = await dispatch('user/whoAmI', condition, {root: true})
        commit('setCurrentProjectMember', member)
      }
    },
    async refreshProject ({state, dispatch}) {
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async getProjectList ({commit, state}, {year, type}) {
      const result = await api.getProjects(year, type)
      commit('setCurrentList', result)
      return result
    },
    async getMembers ({state, commit}) {
      commit('setCurrentMembers', await api.getMembers(state.current._id))
    },
    async getProjectCreatorProjects ({state}) {
      if (!state.current || !state.current.creator) throw new Error('store 沒有 project.current.creator')
      const result = await api.getSubscriberProjects(state.current.creator)
      return result
    },
    async getProjectsBySubscription ({state}, subscriberId) {
      const result = await api.getSubscriberProjects(subscriberId)
      return result
    },
    getProgressReports ({state}) {
      return api.getProgressReports(state.current._id)
    },
    getPayRecords ({state}) {
      return api.getPayRecords(state.current._id)
    },
    async add ({rootState, dispatch, commit, state}, condition) {
      await api.addProject(condition)
      await dispatch('getProjectList', {year: 'All', type: [1, 2]})
    },
    async update ({rootState, dispatch, commit, state}, condition) {
      await api.updateProject(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async delete ({rootState, commit, state}) {
      await api.deleteProject(rootState.project.current._id)
    },
    async deleteMember ({rootState, commit, dispatch, state}, memberId) {
      await api.deleteMemberFromProject(memberId)
    },
    async uploadDailyRecordTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadDailyRecordTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteDailyRecordTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteDailyRecordTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedDailyRecordTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedDailyRecordTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadDailyPayItemsTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadDailyPayItemsTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteDailyPayItemsTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteDailyPayItemsTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedDailyPayItemsTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedDailyPayItemsTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadErrorRecordTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadErrorRecordTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteErrorRecordTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteErrorRecordTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadInspectionListTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadInspectionListTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteInspectionListTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteInspectionListTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedInspectionListTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedInspectionListTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedErrorRecordTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedErrorRecordTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadErrorRecordListTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadErrorRecordListTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteErrorRecordListTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteErrorRecordListTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedErrorRecordListTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedErrorRecordListTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadReviewApplicationTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadReviewApplicationTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteReviewApplicationTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteReviewApplicationTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedReviewApplicationTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedReviewApplicationTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async uploadTestRecordTemplate ({rootState, dispatch, state}, condition) {
      const templateId = await api.uploadTestRecordTemplate(rootState.project.current._id, condition)
      await dispatch('getProjectItemAndStore', state.current._id)
      return templateId
    },
    async deleteTestRecordTemplate ({state, rootState, dispatch}, fileId) {
      await api.deleteTestRecordTemplate(rootState.project.current._id, fileId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async selectedTestRecordTemplate ({state, rootState, dispatch}, templateId) {
      await api.selectedTestRecordTemplate(rootState.project.current._id, templateId)
      await dispatch('getProjectItemAndStore', state.current._id)
    },
    async getProjectProgressDate ({state, rootState, dispatch}, {currentDate, isActual}) {
      try {
        const result = await api.getProjectProgressDate(rootState.project.current._id, currentDate.replace(/\//g, '-'), isActual)
        return result
      } catch (error) {
        if (error.code === 400) return null
        throw error
      }
    },
    async getProjectInfo ({state}, projectId) {
      const result = await api.getProjectInfo(projectId)
      return result
    },
    async updateErrorRecordPrefixCode ({state, commit}, prefix) {
      await api.updateProject(state.current._id, {errorRecordPrefixCode: prefix})
      commit('setErrorRecordCodePrefix', prefix)
    },
    async updateBillboard ({state, dispatch}, billboardImage) {
      await api.updateBillboard(state.current._id, billboardImage)
      await dispatch('refreshProject')
    },
    async deleteBillboard ({state, dispatch}) {
      await api.deleteBillboard(state.current._id)
      await dispatch('refreshProject')
    },
    // Sheet
    async getSheets ({commit, state, rootState}) {
      const result = await api.getSheets(state.current._id)
      return result
    },
    async addSheet ({rootState, dispatch, commit, state}, newSheet) {
      await api.addProject({...newSheet, type: 3, parent: state.current._id})
    },
    async deleteSheetById ({rootState, commit, state}, sheetId) {
      await api.deleteProject(sheetId)
    },
    async getSheetPayItems ({state}) {
      return api.getSheetPayItems(state.current._id)
    },
    async updateSheetPayItems ({state}, payItemIds) {
      await api.updateSheetPayItems({sheetId: state.current._id, payItemIds})
    },
    async updateSheetPayItem ({state}, payItem) {
      await api.updateSheetPayItem({sheetId: state.current._id, payItem})
    },
    // testRecord
    async getTestRecordTodo ({state}) {
      return api.getTestRecordTodo(state.current._id)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/project.js